import { FC, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Box, SxProps, Table, TableBody, TableCell, TableRow, Theme, useTheme } from "@mui/material";
import { ILightingClassConfig, IRoadLayoutConfig } from "types";
import getStyles from "./styles";

type Props = {
  roadLayoutConfig: IRoadLayoutConfig;
  lightingClassConfig: ILightingClassConfig;
  s_state: string | null;
  e_state_left: string;
  e_state_right: string;
  sx?: SxProps<Theme>;
};

const CriteriaTable: FC<Props> = ({ roadLayoutConfig, lightingClassConfig, s_state, e_state_left, e_state_right, sx = {} }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const styles = useMemo(() => getStyles(theme).Criteria, [theme]);

  const roadClass = lightingClassConfig.roadClasses;
  const customRoadClass = lightingClassConfig.customClasses?.mainCustomClass;
  const leftBorderCustomClassType = lightingClassConfig.customClasses?.leftBorderCustomClass?.class_type;
  const rightBorderCustomClassType = lightingClassConfig.customClasses?.rightBorderCustomClass?.class_type;

  return (
    <Table padding="none" sx={{ ...styles.table, ...sx }}>
      <TableBody sx={styles.tbody}>
        <TableRow>
          <TableCell>
            {t("Road")}:{" "}
            {customRoadClass?.class_type ? t("met_sentence3", { standard: customRoadClass.class_type }) : t("met_sentence2", { standard: roadClass })}
          </TableCell>
          <TableCell>
            {(s_state === "met" || s_state === "toohight") && <Box sx={styles.met}>{t("met")}</Box>}
            {s_state === "notmet" && <Box sx={styles.notMet}>{t("not met")}</Box>}
          </TableCell>
        </TableRow>

        {roadLayoutConfig.borderAreaLeft && (
          <TableRow>
            <TableCell>
              {t("Border Area left")}:{" "}
              {leftBorderCustomClassType
                ? t("met_sentence3", { standard: leftBorderCustomClassType })
                : t("met_sentence2", { standard: lightingClassConfig.borderAreaLeftClasses })}
            </TableCell>
            <TableCell>
              {e_state_left === "met" && <Box sx={styles.met}>{t("met")}</Box>}
              {e_state_left === "toohight" && <Box sx={styles.tooHigh}>{t("too high")}</Box>}
              {e_state_left === "notmet" && <Box sx={styles.notMet}>{t("not met")}</Box>}
            </TableCell>
          </TableRow>
        )}

        {roadLayoutConfig.borderAreaRight && (
          <TableRow>
            <TableCell>
              {t("Border Area right")}:{" "}
              {rightBorderCustomClassType
                ? t("met_sentence3", { standard: rightBorderCustomClassType })
                : t("met_sentence2", { standard: lightingClassConfig.borderAreaRightClasses })}
            </TableCell>
            <TableCell>
              {e_state_right === "met" && <Box sx={styles.met}>{t("met")}</Box>}
              {e_state_right === "toohight" && <Box sx={styles.tooHigh}>{t("too high")}</Box>}
              {e_state_right === "notmet" && <Box sx={styles.notMet}>{t("not met")}</Box>}
            </TableCell>
          </TableRow>
        )}
      </TableBody>
    </Table>
  );
};

export default CriteriaTable;
